import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Firebase config dla Oschatz (inny projekt)
const firebaseConfigOschatz = {
    apiKey: "AIzaSyB96QUczIrnC2Mh0pU0MxIhzXXkVszF4kg",
    authDomain: "slam-project-136f8.firebaseapp.com",
    projectId: "slam-project-136f8",
    storageBucket: "slam-project-136f8.appspot.com",
    messagingSenderId: "424948891616",
    appId: "1:424948891616:web:370ac176bb259b031af585",
    measurementId: "G-6R2ZSTB3G9",
};

const app = initializeApp(firebaseConfig);
const appOschatz = initializeApp(firebaseConfigOschatz, "oschatz");

const storage = getStorage(app);
const auth = getAuth(app)
const db = getFirestore(app);
const functions = getFunctions(app);

// Oschatz Firestore
const dbOschatz = getFirestore(appOschatz);

export { db, auth, storage, functions, dbOschatz };